import AccountDefaultsIcon from './AccountDefaultsIcon';
import AccountInfoIcon from './AccountInfoIcon';
import ActionSelectorIcon from './ActionSelectorIcon';
import AdvancedIcon from './AdvancedIcon';
import AddIcon from './AddIcon';
import AgentsIcon from './AgentsIcon';
import AiAssistantIcon from './AiAssistantIcon';
import AiAssistantSettingsIcon from './AiAssistantSettingsIcon';
import AiBrainHandoff from './AiBrainHandoff';
import AiBrainIcon from './AiBrainIcon';
import AiBrainPersonality from './AiBrainPersonality';
import AiKnowledgeBaseIcon from './AiKnowledgeBaseIcon';
import AiQnAIcon from './AiQnAIcon';
import AiUploadDocumentsIcon from './AiUploadDocumentsIcon';
import AiWebsiteScrapingIcon from './AiWebsiteScrapingIcon';
import AppointmentIcon from './AppointmentIcon';
import BackwardIcon from './BackwardIcon';
import BackofficeSettingsIcon from './BackofficeSettingsIcon';
import BillingIcon from './BillingIcon';
import BotIcon from './BotIcon';
import ChatIcon from './ChatIcon';
import CustomizationsIcon from './CustomizationsIcon';
import ContactFormIcon from './ContactFormIcon';
import ControlIcon from './ControlIcon';
import CopyIcon from './CopyIcon';
import DownloadIcon from './DownloadIcon';
import DynamicFormIcon from './DynamicFormIcon';
import EyeIcon from './EyeIcon';
import EnvelopeArrowIcon from './EnvelopeArrowIcon';
import ForwardIcon from './ForwardIcon';
import GoogleAnalyticsBarsIcon from './GoogleAnalyticsBarsIcon';
import GoogleIcon from './GoogleIcon';
import GridIcon from './GridIcon';
import HomeIcon from './HomeIcon';
import HorizontalBarsIcon from './HorizontalBarsIcon';
import IntegrationsIcon from './IntegrationsIcon';
import InstallationCodeIcon from './InstallationCodeIcon';
import ManageWidgetsIcon from './ManageWidgetsIcon';
import MenuThreeDotsIcon from './MenuThreeDotsIcon';
import MessengerIcon from './MessengerIcon';
import MoneyTransferIcon from './MoneyTransferIcon';
import NotificationsIcon from './NotificationsIcon';
import PartnershipsIcon from './PartnershipsIcon';
import PaypalIcon from './PaypalIcon';
import PersonalInformationIcon from './PersonalInformationIcon';
import PhoneIcon from './PhoneIcon';
import SecurityIcon from './SecurityIcon';
import SetUpInstallationIcon from './SetUpInstallationIcon';
import SmtpLogoIcon from './SmtpLogoIcon';
import StylingIcon from './StylingIcon';
import SortIcon from './SortIcon';
import TeamExperienceIcon from './TeamExperienceIcon';
import TickIcon from './TickIcon';
import ThreedIcon from './ThreedIcon';
import UpgradeIcon from './UpgradeIcon';
import UsersIcon from './UsersIcon';
import VideoChatIcon from './VideoChatIcon';
import ZapierLogoIcon from './ZapierLogoIcon';
import WebhookLargeLogoIcon from './WebhookLargeLogoIcon';
import WebhookMediumLogoIcon from './WebhookMediumLogoIcon';
import WhatsAppIcon from './WhatsAppIcon';

const LeftNavigationIcons = {
  AgentsIcon,
  AccountDefaultsIcon,
  AccountInfoIcon,
  ActionSelectorIcon,
  AdvancedIcon,
  AddIcon,
  AiAssistantIcon,
  AiAssistantSettingsIcon,
  AiBrainHandoff,
  AiBrainIcon,
  AiBrainPersonality,
  AiKnowledgeBaseIcon,
  AiQnAIcon,
  AiUploadDocumentsIcon,
  AiWebsiteScrapingIcon,
  AppointmentIcon,
  BackwardIcon,
  BackofficeSettingsIcon,
  BillingIcon,
  BotIcon,
  ChatIcon,
  ContactFormIcon,
  CustomizationsIcon,
  ControlIcon,
  CopyIcon,
  StylingIcon,
  DownloadIcon,
  DynamicFormIcon,
  EyeIcon,
  EnvelopeArrowIcon,
  ForwardIcon,
  GoogleAnalyticsBarsIcon,
  GoogleIcon,
  GridIcon,
  HomeIcon,
  HorizontalBarsIcon,
  InstallationCodeIcon,
  IntegrationsIcon,
  ManageWidgetsIcon,
  MenuThreeDotsIcon,
  MessengerIcon,
  MoneyTransferIcon,
  NotificationsIcon,
  PartnershipsIcon,
  PaypalIcon,
  PersonalInformationIcon,
  PhoneIcon,
  SecurityIcon,
  SetUpInstallationIcon,
  SmtpLogoIcon,
  SortIcon,
  TeamExperienceIcon,
  TickIcon,
  ThreedIcon,
  UpgradeIcon,
  UsersIcon,
  VideoChatIcon,
  ZapierLogoIcon,
  WebhookLargeLogoIcon,
  WebhookMediumLogoIcon,
  WhatsAppIcon,
};

export default LeftNavigationIcons;
